<template>
  <div >
    <div class="back" @click="$router.go(-1)"></div>
    <div class="wrapper">
      <div class="title">
        <Marquee>
          <p>{{name | nameFilter}}</p>
        </Marquee>
      </div>

         <div class="input">
        <p>Camera Name</p>
        <div class="input-container">
      <input type="email" placeholder="Name" v-model="name" />
      </div>
      </div>
         <div class="input">
        <p>Username</p>
        <div class="input-container">
      <input type="email" placeholder="Username" autocorrect="off" autocapitalize="none"
       v-model="username" />
      </div>
      </div>
         <div class="input">
        <p>Password</p>
        <div class="input-container">
      <input type="email" placeholder="Password" autocorrect="off" autocapitalize="none"
       v-model="password" />
      </div>
      </div>

      <button @click="addCamera" :disabled="loading">
        <p v-if="!loading">Add</p> <loading-wheel v-else /> </button>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/EventBus';
import awsInfo from '../../public/websocket';
import LoadingWheel from '../components/LoadingWheel.vue';
import Marquee from '../components/Marquee.vue';

export default {
  filters: {
    nameFilter(name) {
      try {
        return decodeURIComponent(name);
      } catch {
        return name;
      }
    },
  },
  components: { LoadingWheel, Marquee },
  data() {
    return {
      rtsp: '',
      name: '',
      username: '',
      password: '',
      friendlyName: '',
      mac: '',
      type: 'IP',
      url: '',
      enable_video: true,
      enable_audio: false,
      loading: false,

    };
  },
  methods: {
    addCamera() {
      this.loading = true;
      this.$store.dispatch('getOnvifDetail', {
        device: this.device.id,
        mac: this.mac,
        username: this.username,
        password: this.password,
        is_nvr: this.camera.is_nvr,
      });
    },
    async receivedMessageEvent(message) {
      if (message.response === 'GetOnvifConfiguration') {
        if (message.data.error) {
          if (!this.camera) {
            console.error('NOT CAMERA');
            return;
          }
          if (this.camera.is_nvr && !this.camera.channel_name) {
            console.log('Get NVR details failed: ', message);
            this.$store.dispatch('addNotification', {
              type: 'green',
              title: 'Detecting NVR...',
              comment: '',
            });
            this.$store.dispatch('clearCachedOnvifDevice');
            this.$router.go(-1);
          } else {
            this.$store.dispatch('addNotification', {
              type: 'red',
              title: 'Failed to find camera',
              comment: '',
            });
          }
        }
      }
    },
  },
  watch: {
    currentUrl(url) {
      if (url !== null && url !== false) {
        this.url = url;
        awsInfo.addCamera(this.device.id, this.name, this.type,
          this.url, this.mac, this.username, this.password, this.enable_video, this.enable_audio);
        const cameraData = {
          deviceId: this.device.id,
          name: this.name,
          type: this.type,
          url: this.url,
          username: this.username,
          password: this.password,
          audio: this.enable_audio,
          video: this.enable_video,
        };
        this.$store.dispatch('setAddCamera', cameraData);
      } else {
        this.loading = false;
        this.password = '';
      }
    },
    changeRoute(value) {
      if (value !== false) {
        this.$router.go(-1);
      }
    },
  },

  computed: {
    changeRoute() {
      return this.$store.state.changeRoute;
    },
    currentUrl() {
      return this.$store.state.currentUrl;
    },

    camera() {
      return this.$store.getters.onvifCameraFinder(this.$route.params.item);
    },
    device() {
      return this.$store.getters.deviceId(this.$route.params.device);
    },
  },
  created() {
    if (this.$store.state.onvif === null) {
      this.$router.go(-1);
    } else if (this.camera) {
      this.rtsp = this.camera.IP;
      this.name = this.camera.name;
      this.mac = this.camera.MAC;
    }
  },
  mounted() {
    EventBus.$on('receivedMessageEvent', this.receivedMessageEvent);
  },
  beforeUnmount() {
    EventBus.$off('receivedMessageEvent', this.receivedMessageEvent);
  },

};
</script>

<style scoped>
button {
  margin-top: 50px;
  width: 126px;
  height: 63px;
  background-color: var(--surface-dark);
  border-radius: var(--border-radius);
  font-weight: 500;
  font-size: 20px;
}

.input:nth-of-type(2) {
  margin-top: 50px;
}

.title {
  max-width: 250px;
}

.title p {
  margin-top: 20px;
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 52px;
}

.wrapper {
  margin-top: 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
